import type { ColumnVisibilityItem } from "providers/Auth";
import {
  LEADS_COLUMN_ORDER,
  LeadColumnId
} from "shared/app/LeadsTableView/constants";

export const getVisibleLeadColumnIds = ({
  columnsVisibility,
  isOwnerLeadsEnabled,
  isLeadScoringEnabled,
  hidePropertyInterested
}: {
  columnsVisibility: ColumnVisibilityItem[];
  isOwnerLeadsEnabled: boolean;
  isLeadScoringEnabled: boolean;
  hidePropertyInterested: boolean;
}): LeadColumnId[] => {
  const visibilityById = new Map(
    columnsVisibility.map((column) => [column.id, column] as const)
  );

  return LEADS_COLUMN_ORDER.filter((columnId) => {
    if (columnId === LeadColumnId.Type && !isOwnerLeadsEnabled) return false;
    if (columnId === LeadColumnId.Score && !isLeadScoringEnabled) return false;
    if (columnId === LeadColumnId.PropertyInterested && hidePropertyInterested)
      return false;

    const visibility = visibilityById.get(columnId);
    return !visibility || visibility.disabled || visibility.checked;
  });
};

export const getLeadColumnHeader = (
  columnId: LeadColumnId,
  { propertyLabel, unitLabel }: { propertyLabel: string; unitLabel: string }
): string => {
  switch (columnId) {
    case LeadColumnId.Name:
      return "Name";
    case LeadColumnId.PropertyInterested:
      return `${propertyLabel} interested`;
    case LeadColumnId.UnitInterested:
      return `${unitLabel} interested`;
    case LeadColumnId.Type:
      return "Type";
    case LeadColumnId.Source:
      return "Source";
    case LeadColumnId.Tags:
      return "Tags";
    case LeadColumnId.Score:
      return "Approval likelihood";
    case LeadColumnId.PrescreeningResult:
      return "Prescreening result";
    case LeadColumnId.FraudIndicators:
      return "Fraud indicators";
    case LeadColumnId.LastNote:
      return "Last note";
    case LeadColumnId.RecentActivity:
      return "Most recent activity";
    case LeadColumnId.CreatedAt:
      return "Created at";
    case LeadColumnId.AssignedTo:
      return "Assigned to";
    case LeadColumnId.StageSelector:
      return "Current stage";
  }
};
